'use client'
import Link from 'next/link'
import { DOMAttributes, PropsWithChildren, Ref } from 'react'

interface Props {
  className?: string
  href: string
  onClick?: DOMAttributes<HTMLAnchorElement>['onClick']
  ref?: Ref<HTMLAnchorElement>
}

export function PageBtn({ className, children, href, onClick, ref }: PropsWithChildren<Props>) {
  return (
    <Link
      ref={ref}
      href={href}
      onClick={(event) => {
        event.stopPropagation()
        onClick?.(event)
      }}
    >
      <button className={`primary-button text-2xl font-bold ${className}`} type="button">
        {children}
      </button>
    </Link>
  )
}
